window.slimmage = {
    verbose: false,
    tryWebP: true,
    maxWidth: 2048,
    widthStep: 160,
    jpegQuality: 90,
    jpegRetinaQuality: 80,
    webpTimeout: 20
};